﻿import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer>
      <div className="footer">
        <div className="topside-footer">
          <div className="topside-text">
            <h2>Building a more inclusive and open democratic future.</h2>
          </div>
          <div className="topside-links">
            <a href="https://electpoll.com">
              <p>Home</p>
            </a>
            <a href="https://electpoll.com/electally/">
              <p>Electally</p>
            </a>
            <a href="https://electpoll.com/p/about.html">
              <p>About Us</p>
            </a>
            <a href="https://electpoll.com#features">
              <p>Features</p>
            </a>
            <a href="https://electpoll.com#pricing">
              <p>Pricing</p>
            </a>
            <a href="https://x.com/electpoll" target="_blank" rel="noopener noreferrer">
              <p>Twitter</p>
            </a>
          </div>
          <div className="topside-ctas">
            <div className="dhcta">
              <a href="https://electpoll.com/p/create-election.html" target="_blank" rel="noopener noreferrer">
                <p>Create Election</p>
              </a>
            </div>
            <div className="dhcta">
              <a href="https://electpoll.com/mvp" target="_blank" rel="noopener noreferrer">
                <p>View Demo</p>
              </a>
            </div>
          </div>
        </div>
        <div className="bottomside-footer">
          <div className="bottom-logo">
            <img src="/assets/images/electpoll logo (plain white).png" alt="Logo" />
          </div>
          <div className="copyright-socials">
            <div className="copyright">
              <p>© 2025 Electpoll. All Rights Reserved.</p>
            </div>
            <div className="socials">
              <a href="https://www.facebook.com/profile.php?id=61550037581503" target="_blank" rel="noopener noreferrer">
                <img src="/assets/images/fa-brands_facebook-square.svg" alt="facebook" />
              </a>
              <a href="https://x.com/electpoll" target="_blank" rel="noopener noreferrer">
                <img src="/assets/images/fa-brands_twitter-square.svg" alt="twitter" />
              </a>
              <a href="https://www.instagram.com/electpoll" target="_blank" rel="noopener noreferrer">
                <img src="/assets/images/fa-brands_instagram-square.svg" alt="instagram" />
              </a>
              <a href="https://www.linkedin.com/company/electpoll" target="_blank" rel="noopener noreferrer">
                <img src="/assets/images/fa-brands_linkedin.svg" alt="linkedin" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
